import React, { useEffect, useState } from 'react';
import StarRatings from 'react-star-ratings';
import Slider from "react-slick";
import { Route, withRouter, Redirect, Switch, BrowserRouter as Router, NavLink,Link, useHistory} from 'react-router-dom';
import { getBusiness } from '../../Services/business.service';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./home.css"
import b1 from "../../assets/images/b1.jpg"
import b2 from "../../assets/images/b2.jpg"
import profile1 from "../../assets/images/profile1.jpg"
import { Footer } from '../Footer/Footer';

const Home = () => {
    const [businessData,setbusinessData]=useState();
    const [sortedBusiness,setSortedBusiness]=useState();
    const [userSearch,setuserSearch] = useState();
    const history = useHistory();
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,

                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,

                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },

        ]
    };
    const getusersearch = (e) =>{
        setuserSearch(e.target.value);
        console.log('user search is ',e.target.value);
    }
    useEffect(()=>{
        getBusiness().then((res)=>{
            setbusinessData(res);
            // console.log('business Array is',res);
            for (let i=0;i<res.length-1;i++)
            {
                for(let j=i+1;j<res.length;j++){
                    if(res[i].businessCount<res[j].businessCount){
                        let temp = res[j];
                        res[j]=res[i];
                        res[i]=temp;
                    }
                }
            }
            //console.log('response array after sorting is',res);
            setSortedBusiness(res);

        });
    },[])
    return (
        <>
            <div className="homePage1">
                <div className="searchContainer mt-5 pt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <form action="">
                                    <div className="searchDiv">
                                        <div className="w-100 px-2" style={{height:'100%',backgroundColor:'transparent!important'}}>
                                            {/* <label htmlFor="keyword" style={{ display: "none" }}>Keyword</label> */}
                                            <input className="w-100" onChange={getusersearch} type="text" placeholder="What are you looking for?" style={{marginTop:'1rem',border:'none',backgroundColor:'transparent',outline:'none'}} />
                                        </div>
                                        <div className="categoryContainer" >
                                            <label htmlFor="" style={{ display: "none" }}>Category</label>
                                            <i className="fa fa-angle-down"></i>
                                            <select name="category" id="">
                                                <option value="" disabled>Category</option>
                                                <option value="" >Automobile</option>
                                                <option value="" >Entertainment</option>
                                            </select>
                                        </div>
                                        <div className="searchBtnContainer">
                                        {/* {console.log(userSearch)} */}
                                            <button className='btn-success' type="submit" onClick={(e) => e.preventDefault()} style={{backgroundColor:'red!important'}}>
                                             <Link to={`/SearchSpecific/${userSearch}`} className="" style={{height:'100%',color:'black'}}>
                                                <span>Search</span>
                                                <i className="fa fa-angle-right"></i>
                                            </Link>   
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>

                {/* most review section */}
                <section className="container most-review">
                   
                    
                    <div className="reviewHeading-Div">
                        <h1>The Most Reviewed Business</h1>
                        <p>Discover some of the most popular listings which based on user reviews and ratings.</p>
                    </div>
                    <div className="row">
                      {
                        businessData && businessData.map((item,index)=><>
                        <div className=" col-lg-4 col-md-6 mb-3" key={index}> 
                            <BusinessCard data={item}/>
                        </div>
                         </>)
                         
                      }
                    </div>
                    {/* <div className="text-center">
                        <NavLink to="/all-listing" className="ShowMoreBtn" state={{data:businessData}}>Show More<i className="fa fa-angle-right"></i></NavLink>
                    </div> */}
                    <div className="text-center">
                        {/* <button onClick={()=>{history.push({pathname:'/all-listing',state:{data:businessData}})}} className="ShowMoreBtn" >Show More<i className="fa fa-angle-right"></i></button> */}
                        <NavLink to={'/all-listing'}  className="ShowMoreBtn" >Show More<i className="fa fa-angle-right"></i></NavLink>
                    </div>
                </section>

                {/* Nearby Business */}
                <section className="container most-review px-0 nearbyContainer">
                    <div className="reviewHeading-Div">
                        <h1>Top Rated Business</h1>
                    </div>
                    <div>
                    <Slider {...settings}>
                        {/* {
                             businessData && businessData.map((item,index)=>
                               <div className="col" key={index}>
                                   <NearbyBusinessCard data={item} />
                               </div>
                             )
                        } */}
                        {
                             sortedBusiness && sortedBusiness.map((item,index)=>
                               <div className="col" key={index}>
                                   <NearbyBusinessCard data={item} />
                               </div>
                             )
                        }
                        {/* {

                            console.log( 'Sorted business is : ',sortedBusiness)
                        } */}
                            {/* <div className="col">
                                <NearbyBusinessCard />
                            </div>
                            <div className="col">
                                <NearbyBusinessCard />
                            </div>
                            <div className="col">
                                <NearbyBusinessCard />
                            </div> */}

                        </Slider>
                        {/* <Slider {...settings}>
                            <div className="col">
                                <NearbyBusinessCard />
                            </div>
                            <div className="col">
                                <NearbyBusinessCard />
                            </div>
                            <div className="col">
                                <NearbyBusinessCard />
                            </div>
                            <div className="col">
                                <NearbyBusinessCard />
                            </div>

                        </Slider> */}
                    </div>

                </section>

                {/* Community */}
                {/* <section className="joinComunity">
                <div className="container">
                    <div className="communityDiv">
                        <div>
                            <div><h3> Join our community</h3></div>
                            <div>Grow your marketing and be happy with your business</div>
                        </div>
                        <div>
                            <NavLink to="/signup" className="signupBtn" >Sign Up <i className="fa fa-angle-right"></i></NavLink>
                        </div>
                    </div>
                </div>
            </section> */}
            </div>
            {/* <Footer /> */}
        </>
    )
}

const BusinessCard = (props) => {
    return (
        <NavLink className="businessCard" to={`/description/${props.data.businessId}`}>
            <div className="imgDiv">
                {/* <img src={b1} alt="" /> */}
                {/* {console.log('CoverLogo is',props.data)} */}
                <img src={props.data.coverPhotoURL} alt="" />
                <div className="textDiv">
                    <h4 className="mb-3">{props.data.name}</h4>
                    <div><address>{props.data.address } {props.data.city}</address></div>
                    <div className="phone"><i class="fa fa-phone" aria-hidden="true"></i> {props.data.phoneNumber}</div>
                </div>
            </div>
            <div className="ratingDiv">
                <div className="">
                    <StarRatings
                        rating={props.data.businessCount}
                        starDimension="18px"
                        starSpacing="1px"
                        numberOfStars={5}
                        starRatedColor="orange"
                    />
                </div>
                <div className="profileDiv"><img src={props.data.logoURL} alt="" /></div>
            </div>
        </NavLink>

    )
}
const NearbyBusinessCard = (props) => {
    return (
        <NavLink className="businessCard" to={`/description/${props.data.businessId}`}>
        {/* {console.log(props.data.businessId)} */}
            <div className="imgDiv">
                <img src={props.data.coverPhotoURL} alt="" />
                <div className="textDiv">
                    {/* {console.log('Sorted props data is ',props.data)} */}
                    <h4 className="mb-3">{props.data.name}</h4>
                    <div><address>{props.data.address}{props.data.city}</address></div>
                    <div className="phone"><i class="fa fa-phone" aria-hidden="true"></i>{props.data.phoneNumber}</div>
                </div>
            </div>
            <div className="ratingDiv">
                <div className="">
                    <StarRatings
                        rating={props.data.businessCount}
                        starDimension="18px"
                        starSpacing="1px"
                        numberOfStars={5}
                        starRatedColor="orange"
                    />
                </div>
                <div className="profileDiv"><img src={props.data.logoURL} alt="" /></div>
            </div>
        </NavLink>

    )
}
export default Home